export default "__VITE_ASSET__apB0KTpc__"